import { FormattedMessage, useIntl } from "react-intl";
import styles from "./BrandedCollections.module.scss";
import { clsx } from "clsx";
import Swimlane from "../../../../common/core-ui/Swimlane.tsx";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { useHomeContextUser } from "../../../home/homeContext.ts";
import Section from "../common/Section.tsx";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import defaultBackground from "../../explore-integrated/subscription/background-dots.jpg";
import { UnsafeHtml } from "../../../../common/core-ui/UnsafeHtml.tsx";

interface Props {
  className?: string;
}

export default function BrandedCollections({ className }: Props) {
  const intl = useIntl();
  const brand = useBrandLoaderData();
  const { exploreBranding } = useHomeContextUser();
  const brandedCollections = Object.values(exploreBranding).filter(
    (c) => c.branded
  );

  if (!brand.Explore.enabled || !brandedCollections.length) {
    return null;
  }

  return (
    <Section
      title={intl.formatMessage({
        defaultMessage: "My Collections",
      })}
      subtitle={intl.formatMessage({
        defaultMessage:
          "View the collections that have been added to your account.",
      })}
      gridClassName={styles.grid}
    >
      <Swimlane className={styles.swimlane} keepItemsReachable flexibleSize>
        {brandedCollections.map((collection) => (
          <li key={collection.vbid}>
            <div
              className={clsx(styles.card, className)}
              style={
                {
                  "--card-image": `url(${
                    collection.image ?? defaultBackground
                  })`,
                } as React.CSSProperties
              }
            >
              <div className={styles.cardTitle}>{collection.title}</div>
              <UnsafeHtml className={styles.cardDescription} color="inherit">
                {collection.description}
              </UnsafeHtml>
              <div className={styles.cardButtonContainer}>
                <BaseLinkOrButton
                  aria-label={intl.formatMessage(
                    {
                      defaultMessage: "View Collection {title}",
                    },
                    { title: collection.title }
                  )}
                  className={clsx(
                    "vst-button-pill",
                    "vst-button-variant-white-outline",
                    "vst-button-size-small"
                  )}
                  to={`/explore/${collection.vbid}`}
                >
                  <FormattedMessage defaultMessage="View Collection" />
                </BaseLinkOrButton>
              </div>
            </div>
          </li>
        ))}
      </Swimlane>
    </Section>
  );
}
